import React from 'react';

/**
 * AppButton — pure-DOM button with semantic variants.
 *
 * Variants: 'success' (CTA green), 'info' (blue), 'gradient' (border gradient),
 *           'secondary' (border), 'ghost' (minimal).
 * 'primary' is kept as an alias for 'success' for backward compatibility.
 * Sizes: 'md' (default), 'sm'.
 */
const AppButton = ({
    label,
    icon,
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    disabled = false,
    loading = false,
    onClick,
    type = 'button',
    className = '',
    children,
    ...rest
}) => {
    const resolved = variant === 'primary' ? 'success' : variant;
    const iconSize = size === 'sm' ? '0.7rem' : '0.8rem';

    const cls = [
        'fk-btn',
        `fk-btn--${resolved}`,
        `fk-btn--${size}`,
        fullWidth && 'fk-btn--full',
        className,
    ].filter(Boolean).join(' ');

    return (
        <button
            className={cls}
            disabled={disabled || loading}
            onClick={onClick}
            type={type}
            {...rest}
        >
            <span className="fk-btn__content">
                {loading && <i className="pi pi-spin pi-spinner" style={{ fontSize: iconSize }} />}
                {!loading && icon && <i className={icon} style={{ fontSize: iconSize }} />}
                {label || children}
            </span>
        </button>
    );
};

export default AppButton;
